var pomUpdates = require('ub_legacy/lp/pom/updates/updates');

pomUpdates.add( Object.extend( {
  minVersion: '2.4',
  version: '2.5',
  run: function(jso) {
    if( this.checkVersion( jso ) ) {
      var self = this;
      jso.elements.each( function( el ) {
        if( el.type === 'lp-pom-text' ) {
          el = self.addStyle(el);
        }
      } );
      jso.version = this.version;
    }
  },

  addStyle: function(e) {
    if(!e.style) {e.style = {};}
    if(!e.style.background) {
      e.style.background = {
        backgroundColor: 'fff',
        opacity: 0
      };
    }
    return e ;
  }


}, window.lp.pom.updater ) );



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/pom/updates/2.5.js
// module id = 442
// module chunks = 0 1